import React, { useState, useMemo } from "react";

import DashboardView from "./DashboardView";

// ---------- Mock Data for Dashboard / Commission ----------
const mockRetailers = [
  {
    id: 1,
    name: "Shree Mobile Store",
    code: "RT001",
    city: "Pune",
    onboardDate: "2025-09-10",
    isActive: true,
    isSelling: true,
    monthlySales: 75000,
    totalSales: 450000,
    commissionRate: 0.04, // 4%
    monthCommission: 3000,
    totalCommission: 18000,
  },
  {
    id: 2,
    name: "Sai Telecom",
    code: "RT002",
    city: "Mumbai",
    onboardDate: "2025-10-05",
    isActive: true,
    isSelling: false,
    monthlySales: 12000,
    totalSales: 120000,
    commissionRate: 0.035,
    monthCommission: 420,
    totalCommission: 4200,
  },
  {
    id: 3,
    name: "Om Electronics",
    code: "RT003",
    city: "Nashik",
    onboardDate: "2025-07-20",
    isActive: false,
    isSelling: false,
    monthlySales: 0,
    totalSales: 80000,
    commissionRate: 0.03,
    monthCommission: 0,
    totalCommission: 2400,
  },
  {
    id: 4,
    name: "Mahalaxmi General Store",
    code: "RT004",
    city: "Aurangabad",
    onboardDate: "2025-11-01",
    isActive: true,
    isSelling: true,
    monthlySales: 50000,
    totalSales: 50000,
    commissionRate: 0.05,
    monthCommission: 2500,
    totalCommission: 2500,
  },
];

const commissionTrend = [
  { month: "Jun", commission: 8000, target: 7000 },
  { month: "Jul", commission: 9500, target: 9000 },
  { month: "Aug", commission: 11000, target: 10000 },
  { month: "Sep", commission: 13000, target: 12000 },
  { month: "Oct", commission: 14500, target: 13000 },
  { month: "Nov", commission: 15500, target: 15000 },
];

function AgentDashboard() {
  const [currentView, setCurrentView] = useState("dashboard"); // 'dashboard' | 'retailers' | 'commission'
  const [filterType, setFilterType] = useState(null);

  // ---------- KPI Calculations ----------
  const kpis = useMemo(() => {
    const safeRetailers = mockRetailers || [];

    const totalOnboarded = safeRetailers.length;
    const activeRetailers = safeRetailers.filter((r) => r.isActive).length;
    const sellingRetailers = safeRetailers.filter((r) => r.isSelling).length;

    const monthSales = safeRetailers.reduce(
      (sum, r) => sum + (r.monthlySales || 0),
      0
    );
    const lifetimeSales = safeRetailers.reduce(
      (sum, r) => sum + (r.totalSales || 0),
      0
    );
    const monthCommission = safeRetailers.reduce(
      (sum, r) => sum + (r.monthCommission || 0),
      0
    );
    const lifetimeCommission = safeRetailers.reduce(
      (sum, r) => sum + (r.totalCommission || 0),
      0
    );

    const avgCommissionPerRetailer = totalOnboarded
      ? monthCommission / totalOnboarded
      : 0;

    return {
      totalOnboarded,
      activeRetailers,
      sellingRetailers,
      monthSales,
      lifetimeSales,
      monthCommission,
      lifetimeCommission,
      avgCommissionPerRetailer,
    };
  }, []);

  // Retailer-wise commission data for chart
  const retailerCommissionChartData = useMemo(() => {
    return mockRetailers.map((r) => ({
      name: r.name,
      monthCommission: r.monthCommission,
    }));
  }, []);

  return (
    
      <div className="flex-1 flex flex-col">

        {/* Main Body */}
        <main className="flex-1 p-4 md:p-6">
          {currentView === "dashboard" && (
            <DashboardView
              kpis={kpis}
              commissionTrend={commissionTrend}
              retailerCommissionChartData={retailerCommissionChartData}
              retailers={mockRetailers}
              setFilterType={setFilterType}
              setCurrentView={setCurrentView}
              
            />
          )}
        </main>
      </div>
  );
}

export default AgentDashboard;



// import React, { useState, useMemo } from "react";

// import DashboardView from "./DashboardView";
// import RetailersView from "./Retailer/RetailersView";
// import CommissionView from "./CommissionView";


// const mockRetailers = [
//   {
//     id: 1,
//     name: "Shree Mobile Store",
//     code: "RT001",
//     city: "Pune",
//     onboardDate: "2025-09-10",
//     isActive: true,
//     isSelling: true,
//     monthlySales: 75000,
//     totalSales: 450000,
//     commissionRate: 0.04, // 4%
//     monthCommission: 3000,
//     totalCommission: 18000,
//   },
//   {
//     id: 2,
//     name: "Sai Telecom",
//     code: "RT002",
//     city: "Mumbai",
//     onboardDate: "2025-10-05",
//     isActive: true,
//     isSelling: false,
//     monthlySales: 12000,
//     totalSales: 120000,
//     commissionRate: 0.035,
//     monthCommission: 420,
//     totalCommission: 4200,
//   },
//   {
//     id: 3,
//     name: "Om Electronics",
//     code: "RT003",
//     city: "Nashik",
//     onboardDate: "2025-07-20",
//     isActive: false,
//     isSelling: false,
//     monthlySales: 0,
//     totalSales: 80000,
//     commissionRate: 0.03,
//     monthCommission: 0,
//     totalCommission: 2400,
//   },
//   {
//     id: 4,
//     name: "Mahalaxmi General Store",
//     code: "RT004",
//     city: "Aurangabad",
//     onboardDate: "2025-11-01",
//     isActive: true,
//     isSelling: true,
//     monthlySales: 50000,
//     totalSales: 50000,
//     commissionRate: 0.05,
//     monthCommission: 2500,
//     totalCommission: 2500,
//   },
// ];

// const commissionTrend = [
//   { month: "Jun", commission: 8000, target: 7000 },
//   { month: "Jul", commission: 9500, target: 9000 },
//   { month: "Aug", commission: 11000, target: 10000 },
//   { month: "Sep", commission: 13000, target: 12000 },
//   { month: "Oct", commission: 14500, target: 13000 },
//   { month: "Nov", commission: 15500, target: 15000 },
// ];

// const mockCommissionEntries = [
//   {
//     id: 501,
//     date: "2025-11-10",
//     retailerId: 1,
//     retailerName: "Shree Mobile Store",
//     invoiceAmount: 25000,
//     rate: 0.04,
//     commissionAmount: 1000,
//     remark: "Recharge + DMT",
//   },
//   {
//     id: 502,
//     date: "2025-11-09",
//     retailerId: 4,
//     retailerName: "Mahalaxmi General Store",
//     invoiceAmount: 20000,
//     rate: 0.05,
//     commissionAmount: 1000,
//     remark: "POS license + bill pay",
//   },
//   {
//     id: 503,
//     date: "2025-11-05",
//     retailerId: 2,
//     retailerName: "Sai Telecom",
//     invoiceAmount: 12000,
//     rate: 0.035,
//     commissionAmount: 420,
//     remark: "Low activity month",
//   },
// ];

// // Weekly combined payouts for the agent
// const mockPayouts = [
//   {
//     id: 801,
//     weekLabel: "Week 1: 03 Nov - 09 Nov 2025",
//     weekStart: "2025-11-03",
//     weekEnd: "2025-11-09",
//     totalCommission: 2420,
//     payoutStatus: "Transferred", // 'Transferred' | 'Pending'
//     bankName: "HDFC Bank",
//     accountNumberLast4: "4321",
//     ifsc: "HDFC0001234",
//     transactionId: "TXN20251110001",
//     payoutDate: "2025-11-10",
//   },
//   {
//     id: 802,
//     weekLabel: "Week 2: 10 Nov - 16 Nov 2025",
//     weekStart: "2025-11-10",
//     weekEnd: "2025-11-16",
//     totalCommission: 1800,
//     payoutStatus: "Pending",
//     bankName: "SBI",
//     accountNumberLast4: "7788",
//     ifsc: "SBIN0005678",
//     transactionId: "",
//     payoutDate: "",
//   },
// ];

// function AgentDashboard() {
//   const [retailers] = useState(mockRetailers);
//   const [commissionEntries] = useState(mockCommissionEntries);
//   const [payouts] = useState(mockPayouts);
//   const [currentView, setCurrentView] = useState("dashboard"); // 'dashboard' | 'retailers' | 'commission'
//   const [searchRetailer, setSearchRetailer] = useState("");
  // const [filterType, setFilterType] = useState(null);
//   const [selectedRetailerId, setSelectedRetailerId] = useState(
//     mockRetailers[0]?.id ?? null
//   );

//   const selectedRetailer = useMemo(
//     () => retailers.find((r) => r.id === selectedRetailerId),
//     [retailers, selectedRetailerId]
//   );

//   // ---------- KPI Calculations ----------

//   const kpis = useMemo(() => {
//     const safeRetailers = retailers || [];

//     const totalOnboarded = safeRetailers.length;
//     const activeRetailers = safeRetailers.filter((r) => r.isActive).length;
//     const sellingRetailers = safeRetailers.filter((r) => r.isSelling).length;

//     const monthSales = safeRetailers.reduce(
//       (sum, r) => sum + (r.monthlySales || 0),
//       0
//     );
//     const lifetimeSales = safeRetailers.reduce(
//       (sum, r) => sum + (r.totalSales || 0),
//       0
//     );
//     const monthCommission = safeRetailers.reduce(
//       (sum, r) => sum + (r.monthCommission || 0),
//       0
//     );
//     const lifetimeCommission = safeRetailers.reduce(
//       (sum, r) => sum + (r.totalCommission || 0),
//       0
//     );

//     const avgCommissionPerRetailer = totalOnboarded
//       ? monthCommission / totalOnboarded
//       : 0;

//     return {
//       totalOnboarded,
//       activeRetailers,
//       sellingRetailers,
//       monthSales,
//       lifetimeSales,
//       monthCommission,
//       lifetimeCommission,
//       avgCommissionPerRetailer,
//     };
//   }, [retailers]);

//   // ---------- Filtered Retailers ----------

//  const filteredRetailers = useMemo(() => {
//   let safeRetailers = retailers || [];

//   // 👉 KPI FILTERS
//   if (filterType === "onboarded") {
//     safeRetailers = safeRetailers.filter(r => r.isOnboarded === true || r.onboardDate);
//   }

//   if (filterType === "selling") {
//     safeRetailers = safeRetailers.filter(r => r.isSelling === true);
//   }

//   if (filterType === "monthSales") {
//     safeRetailers = safeRetailers.filter(r => r.monthlySales > 0);
//   }

//   if (filterType === "monthCommission") {
//     safeRetailers = safeRetailers.filter(r => r.monthCommission > 0);
//   }

//   // 👉 SEARCH FILTER
//   if (searchRetailer.trim()) {
//     const q = searchRetailer.toLowerCase();
//     safeRetailers = safeRetailers.filter(
//       r =>
//         r.name.toLowerCase().includes(q) ||
//         r.code.toLowerCase().includes(q) ||
//         r.city.toLowerCase().includes(q)
//     );
//   }

//   return safeRetailers;
// }, [retailers, filterType, searchRetailer]);



//   // Retailer-wise commission data for chart
//   const retailerCommissionChartData = useMemo(() => {
//     const safeRetailers = retailers || [];
//     return safeRetailers.map((r) => ({
//       name: r.name,
//       monthCommission: r.monthCommission,
//     }));
//   }, [retailers]);

//   // ---------- Layout ----------

//   return (
//     <div className="min-h-screen bg-slate-100 flex text-slate-900">
//       {/* Sidebar (desktop) */}
//       <aside className="hidden md:flex md:flex-col w-64 bg-white border-r border-slate-200">
//         <div className="px-4 py-4 border-b border-slate-100">
//           <div className="text-xs font-semibold tracking-wide text-blue-600 uppercase">
//             Agent
//           </div>
//           <div className="text-lg font-bold text-slate-800">
//             Onboarding Dashboard
//           </div>
//         </div>
//         <nav className="flex-1 px-2 py-4 space-y-1 text-sm">
//           {[
//             { id: "dashboard", label: "Dashboard" },
//             { id: "retailers", label: "Retailers & Earnings" },
//             { id: "commission", label: "Commission Report" },
//           ].map((item) => (
//             <button
//               key={item.id}
//               onClick={() => setCurrentView(item.id)}
//               className={`w-full text-left px-3 py-2 rounded-xl font-medium ${
//                 currentView === item.id
//                   ? "bg-blue-600 text-white shadow-sm"
//                   : "text-slate-700 hover:bg-blue-50"
//               }`}
//             >
//               {item.label}
//             </button>
//           ))}
//         </nav>
//         <div className="px-4 py-4 border-t border-slate-100 text-xs text-slate-500">
//           Logged in as <span className="font-semibold">Agent</span>
//         </div>
//       </aside>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header / Mobile Nav */}
//         <header className="sticky top-0 z-10 bg-white border-b border-slate-200 px-4 py-3 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
//           <div>
//             <div className="md:hidden text-xs font-semibold tracking-wide text-blue-600 uppercase">
//               Agent
//             </div>
//             <h1 className="text-base md:text-lg font-semibold text-slate-800">
//               {currentView === "dashboard" && "My Performance Overview"}
//               {currentView === "retailers" && "Retailers & Earnings"}
//               {currentView === "commission" && "Commission Report"}
//             </h1>
//             <p className="text-xs text-slate-500 hidden md:block">
//               Track retailers you onboard, their sales, and your commissions.
//             </p>
//           </div>
//           <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3">
//             {/* Mobile nav tabs */}
//             <div className="flex md:hidden rounded-2xl bg-slate-100 p-1 text-[11px] font-medium">
//               {["dashboard", "retailers", "commission"].map((item) => (
//                 <button
//                   key={item}
//                   onClick={() => setCurrentView(item)}
//                   className={`flex-1 px-2 py-1 rounded-2xl text-center ${
//                     currentView === item
//                       ? "bg-blue-600 text-white shadow-sm"
//                       : "text-slate-700"
//                   }`}
//                 >
//                   {item === "dashboard" && "Dashboard"}
//                   {item === "retailers" && "Retailers"}
//                   {item === "commission" && "Commission"}
//                 </button>
//               ))}
//             </div>
//             {/* Filter placeholder */}
//             <select className="text-xs border border-slate-200 rounded-lg px-2 py-1 bg-slate-50 self-end md:self-auto">
//               <option>Current Month</option>
//               <option>Last 3 Months</option>
//               <option>Last 6 Months</option>
//               <option>Year to Date</option>
//             </select>
//           </div>
//         </header>

//         {/* Main Body */}
//         <main className="flex-1 p-4 md:p-6">
//           {currentView === "dashboard" && (
//             <DashboardView
//               kpis={kpis}
//               commissionTrend={commissionTrend}
//               retailerCommissionChartData={retailerCommissionChartData}
//               retailers={retailers}
//               setCurrentView={setCurrentView}
//               setFilterType={setFilterType}
//             />
//           )}

//           {currentView === "retailers" && (
//             <RetailersView
//               retailers={filteredRetailers}
//               allRetailers={retailers}
//               searchRetailer={searchRetailer}
//               setSearchRetailer={setSearchRetailer}
//               selectedRetailer={selectedRetailer}
//               setSelectedRetailerId={setSelectedRetailerId}
//             />
//           )}

//           {currentView === "commission" && (
//             <CommissionView
//               kpis={kpis}
//               commissionEntries={commissionEntries}
//               payouts={payouts}
//               retailers={retailers}
//             />
//           )}
//         </main>
//       </div>
//     </div>
//   );
// }

// export default AgentDashboard;


